var _ = require('underscore');
var Entities = require('Entities');
var StatusType = EY.Consultation.Lookups.StatusType;

var set = function (options) {
    var approvers = new Entities.Approvers(options.approvers.reject({ upn: '' }));
    var record = options.record;        
    var status = record.get('statusTypeId');

    if (record.get('statusTypeId') == StatusType.ReviewApproval) {
        var approver = approvers.find({ approverGroupId: record.get('approverGroupId'), upn: record.get('assignedTo') });
        var group = 'ApproverGroup_' + record.get('approverGroupId') + '.';
        var role = approver.get('rank') ? record.get('approverGroupId') + '_' + _.invert(EY.Consultation.Lookups[record.get('approverGroupId') + 'Type'])[approver.get('rank')] + '.' : '';

        status = group + role + status;
    } 
    record.set('statusResourceKey', status);
};

module.exports.set = function (options) {
    set(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordStatus.js